import { Component, OnInit, ViewChild } from "@angular/core";

import { ClientesService } from "../../services/clientes.service";
import { Utilservice } from "@core/services/util.service";
import * as _ from 'lodash';
import * as toastr from 'toastr'
import { Setor, Vendedor } from '@shared/models';
import { VisitasService } from '@modules/visitas/services/visitas.service';

@Component({
  selector: "app-debitos-aberto",
  templateUrl: "./debitos-aberto.component.html",
  styleUrls: ["./debitos-aberto.component.css"]
})
export class DebitosAbertoComponent implements OnInit {
  routerName: string = "Débitos em Aberto";

  lsSetores: any[] = [];
  lsTipoDebito: any[] = [];
  lsPortador: any[] = [];
  lsClients: any[] = [];
  lsVendedores: Vendedor[] = [];

  vendedor : Vendedor;
  vendedorLoading : boolean = false;
  isRequesting: Boolean = false;
  parameters: any;
  vetorSetor: any;
  userLogado;
  setorCdFzs = null;

  private debouncedGetSetor =  _.debounce(()=>this.getIdSetorComc(), 1000, {
    'leading': false,
    'trailing': true
  })

  constructor(
    private clientService: ClientesService,
    private visitService: VisitasService,
    ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.getSetores();
    this.getPortador();
    this.getTipoDebito();

    this.setorCdFzs = this.userLogado.perfil !== 3 ? this.userLogado.setor : null;

    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.vetorSetor = {
        id: this.userLogado.idSetor,
        codigo: this.userLogado.setor,
      }
    }

    if(this.userLogado.perfil == 5){
      this.setorCdFzs = '';
    }

    this.parameters = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : null,
      periodoInicial: "",
      periodoFinal: "",
      cnpj: "0",
      razaoSocial: "",
      tipoDebito: "0",
      portador: "0",
      qtdDiasVencimento: "0",
      noDuplicata: "",
      noRecibo: "",
      restricao: "",
      vendedor: null,
      codigoSetor: "",
      CdFzs: ""
    };

    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.getVendedores();
    }    
  }

  getSetores() {
    this.clientService
      .getSetores()
      .subscribe(
        data => (this.lsSetores = data),
        error => console.log(error),
        () => console.log("States Loaded")
      );
  }

  getPortador() {
    this.clientService
      .getPortador()
      .subscribe(
        data => (this.lsPortador = data),
        error => console.log(error),
        () => console.log("States Loaded")
      );
  }

  getTipoDebito() {
    this.clientService
      .getTipoDebito()
      .subscribe(
        data => (this.lsTipoDebito = data),
        error => console.log(error),
        () => console.log("States Loaded")
      );
  }

  getVendedores(){
    this.parameters.vendedor = '';
    this.vendedorLoading = true;
    this.visitService.getVendedoresPorSetor(this.vetorSetor.codigo).subscribe(
      data => {
        this.lsVendedores = data;

        if (data.length == 1) {
          this.parameters.vendedor = data[0];
        }
        else {
          this.parameters.vendedor = null;
        }

        this.vendedorLoading = false;
    },
      error => console.log(error)
    );
  }

  getClients() {
    this.isRequesting = true;

    const parameters = { ...this.parameters };

    parameters.codigoSetor = this.setorCdFzs;

    if(!this.vetorSetor){
      toastr.error('Campo "Setor" Obrigatório')
      this.isRequesting = false
      return false;
    }

    if(!parameters.vendedor){
      toastr.error('Campo "Vendedor" Obrigatório');
      this.isRequesting = false
      return false;
    }
    else {
      parameters.vendedor = parameters.vendedor.setor;
    }

    parameters.cnpj = parameters.cnpj.replace(/[^\d]/g, "");
    if(!parameters.cnpj)
      parameters.cnpj = 0;
    if(!parameters.tipoDebito)
      parameters.tipoDebito = 0;
    if(!parameters.portador)
      parameters.portador = 0;
    if(!parameters.qtdDiasVencimento)
      parameters.qtdDiasVencimento = 0;



    Object.keys(parameters).forEach(key => {
      if (!parameters[key]) {
        delete parameters[key];
      }
    });
    console.log("parameters", parameters)
    this.clientService
      .getDebitoEmAberto(parameters)
      .finally(() => (this.isRequesting = false))
      .subscribe(
        data => {
          this.lsClients = data;
        },
        error => console.log(error)
      );
  }

  reset() {
    this.parameters = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : null,
      periodoInicial: "",
      periodoFinal: "",
      cnpj: "",
      razaoSocial: "",
      tipoDebito: "",
      portador: "",
      qtdDiasVencimento: "",
      noDuplicata: "",
      noRecibo: "",
      restricao: "",
      vendedor: null,
      codigoSetor: "",
      CdFzs: ""
    };

    this.lsClients = []
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  formatDate(date) {
    let unformatedDate = date;

    if (String(unformatedDate).indexOf("T") >= 0) {
      const split = unformatedDate.split("T");

      unformatedDate = split[0]
        .split("-")
        .reverse()
        .join("/");
    }

    return Utilservice.formatDate(unformatedDate);
  }

  formatCep(cep) {
    return Utilservice.formatCep(cep);
  }

  blockAllButPositiveNumbers(event){
    if (
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode != 8 &&
      event.keyCode != 13 &&
      event.keyCode != 46 &&
      event.keyCode != 37 &&
      event.keyCode != 39
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  blockAllButPositiveNumbersAndLetters(event){
    if (
      (event.keyCode < 48 || event.keyCode > 91) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode != 8 &&
      event.keyCode != 13 &&
      event.keyCode != 46 &&
      event.keyCode != 37 &&
      event.keyCode != 39
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  getIdSetorComc(){
    if(this.vetorSetor){
      this.parameters.CdFzs = this.vetorSetor.codigo;
      this.setorCdFzs = this.vetorSetor.codigo;
    }

    this.clientService.getIdSetor(this.setorCdFzs)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            this.parameters.idSetorComC = idSetor;
            this.parameters.setor = idSetor;
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  onSetorChange(event){
    this.debouncedGetSetor()
  }
}
